import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_CLEAN,
  RESTORE_PASSWORD,
  RESTORE_PASSWORD_SUCCESS,
  RESTORE_PASSWORD_ERROR,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  forgetLoading: false,
  restoreSuccessMsg: null,
  restoreError: null,
  restoreLoading: false,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetLoading: true,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetLoading: false,
        forgetError: null,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, forgetLoading: false }
      break
    case FORGET_PASSWORD_CLEAN:
      state = {
        ...state,
        forgetError: null,
        forgetLoading: false,
        forgetSuccessMsg: null,
      }
      break
    case RESTORE_PASSWORD:
      state = {
        ...state,
        restoreLoading: true,
        restoreSuccessMsg: null,
        restoreError: null,
      }
      break
    case RESTORE_PASSWORD_SUCCESS:
      state = {
        ...state,
        restoreLoading: false,
        restoreSuccessMsg: action.payload,
      }
      break
    case RESTORE_PASSWORD_ERROR:
      state = { ...state, restoreError: action.payload, restoreLoading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
